export type BulkSurveyIdentity = {
  name: string;
  siteId: string;
  siteName: string;
  buildingId: string;
  buildingName: string;
};

export type SurveyQuery = {
  where(fieldPath: string, operator: '==', value: unknown): SurveyQuery;
  limit(limit: number): SurveyQuery;
  get(): Promise<{ empty: boolean }>;
};

export async function findExistingBulkSurveyDuplicates(
  surveys: SurveyQuery,
  candidates: BulkSurveyIdentity[],
) {
  const matches = await Promise.all(
    candidates.map(async (candidate) => {
      const snapshot = await surveys
        .where('name', '==', candidate.name)
        .where('siteId', '==', candidate.siteId)
        .where('buildingId', '==', candidate.buildingId)
        .where('deleted', '==', 0)
        .limit(1)
        .get();

      return snapshot.empty ? null : candidate;
    }),
  );

  return matches.filter(
    (candidate): candidate is BulkSurveyIdentity => candidate !== null,
  );
}
